export default {"src":"https://cdn.tanzhi.cn/_next/static/media/person-c.d26b003b.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};